{
  "$id": "module://customer-success-automation",
  "$schema": "wealthlane://schemas/domain",
  "title": "Customer Success Automation",
  "type": "object",
  "properties": {
    "sourceCompanyId": {
      "type": "string",
      "title": "Company",
      "widget": "select",
      "actionId": "FETCH_CUSTOMER_SUCCESS_SOURCE_COMPANY_OPTIONS",
      "placeholder": "Select source company",
      "required": true
    },
    "sourceRoleId": {
      "type": "string",
      "title": "Role Publish",
      "widget": "select",
      "actionId": "FETCH_VENDOR_SELF_ROLES_BY_COMPANY",
      "placeholder": "Select role publish",
      "required": true
    },
    "destinationCompanyId": {
      "type": "string",
      "title": "Company",
      "widget": "select",
      "actionId": "FETCH_CUSTOMER_SUCCESS_SOURCE_COMPANY_OPTIONS",
      "placeholder": "Select destination company",
      "required": true
    },
    "destinationRoleId": {
      "type": "string",
      "title": "Role Mapping",
      "widget": "select",
      "actionId": "FETCH_VENDOR_SELF_ROLES_BY_COMPANY",
      "placeholder": "Select role mapping",
      "required": true
    }
  }
}
